import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, fToCurrency } from '@web/utils';
import { PLineItem } from '@/hooks/useUserLineItemsPagination';
import { useAppSelector } from '@/store/hooks';

interface CaroyselItemProps {
  lineItem: PLineItem;
  handleOrderAgain?: (a: PLineItem) => void;
  handleClick: (a: PLineItem) => void;
}

const CarouselItem = (props: CaroyselItemProps) => {
  const { t } = useTranslation();
  const { lineItem, handleOrderAgain, handleClick } = props;

  const isOrderAgainEnabled = useAppSelector((state) => state.retailer);

  // console.log({isOrderAgainEnabled})

  const showOrderAgain = useMemo(() => {
    return (
      isOrderAgainEnabled &&
      !!lineItem.inventory?.articleData?.id &&
      !!lineItem.delivery?.type
    );
  }, [
    isOrderAgainEnabled,
    lineItem.delivery?.type,
    lineItem.inventory?.articleData?.id,
  ]);

  const handleOrderAgainPress = (e) => {
    e.stopPropagation();
    handleOrderAgain?.(lineItem);
  };

  return (
    <div
      className="my-1-0 gap-4-0 p-3-0 md:p-2-0 w-full rounded-10-0 shadow-md"
      onClick={() => handleClick(lineItem)}
    >
      <div>
        <p className="title font-bd text-2-6 md:text-body1 leading-1-33 md:leading-body1 min-h-[3rem] line-clamp-2">
          {lineItem.name}
        </p>
      </div>

      <div className="flex justify-between mt-1-0">
        <div>
          <p className="text-body1 font-md">
            {lineItem.lineTotalQuantity} {lineItem.unit} —{' '}
            <span className="text-body1 font-md">
              {fToCurrency(lineItem.lineTotalNet ?? 0)}
            </span>
          </p>
          {lineItem.delivery?.siloName && (
            <p className="text-body1 font-md">{lineItem.delivery?.siloName}</p>
          )}
        </div>
        <div className="min-h-[3.8rem]">
          {showOrderAgain && handleOrderAgain && (
            <Button
              onClick={handleOrderAgainPress}
              variant={
                lineItem.inventory?.visibleForCustomers
                  ? 'primary'
                  : 'secondary'
              }
            >
              {t('inventory.order_again')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CarouselItem;
